<template>
  <div v-if="data">
    <div
      v-for="(previousDebtors, index) in data"
      :key="previousDebtors + index + Math.random()"
    >
      <div v-if="previousDebtors" class="form-base__title preview break">
        {{ `Должник №${index + 1}` }}
      </div>

      <div v-if="previousDebtors" class="row-box mb-5">
        <Person :data="previousDebtors" v-if="previousDebtors.person" />
        <Organization
          :data="previousDebtors"
          v-if="previousDebtors.organization"
        />
        <ForeignOrganization
          :data="previousDebtors"
          v-if="previousDebtors.foreignOrganization"
        />

        <div class="row-box" v-if="previousDebtors.changeReason">
          <WrapperField
            :data="createDataField({fieldName: 'changeReason', fieldValue: previousDebtors.changeReason, fieldGroup: 'previousDebtors'})"
          ></WrapperField>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import Person from '@/components/elements/statement/FullStatementView/elements/Person';
import Organization from '@/components/elements/statement/FullStatementView/elements/Organization';
import ForeignOrganization from '@/components/elements/statement/FullStatementView/elements/ForeignOrganization';

export default {
  name: 'Step4',
  components: {
    WrapperField,
    ForeignOrganization,
    Organization,
    Person,
  },
  props: ['data'],
  data: () => ({
    createDataField,
  }),
};
</script>